import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TARGETING_API_BASE_URL } from '../constants';
import { OwnershipSource, ScoreboardTarget, ScoreboardTypeFilter } from '../models';

@Injectable()
export class TargetingScoreboardRepository {
  public getTargets(
    filter: ScoreboardTypeFilter,
    securityId: number,
    source: OwnershipSource,
    take = 10
  ): Observable<ScoreboardTarget[]> {
    const params = new HttpParams({ fromObject: { rating: `${filter}`, source, take } });
    return this.http.get<ScoreboardTarget[]>(
      `${TARGETING_API_BASE_URL}/securities/${securityId}/institutions/scoreboards`,
      {
        params
      }
    );
  }
  constructor(private http: HttpClient) {}
}
